import type { UseFormPayload } from '@domain-group/react-hooks'

import { Button, DashboardModule, Form } from '@domain-group/suit-theme'

import useAccountingIntegration from '@hooks/useAccountingIntegration'

import AccountingIntegrationButton from '@components/AccountingIntegrationButton'

import ActiveSession from './ActiveSession'

interface AccountingProps {
  agencyFormPayload: UseFormPayload,
  disabled: boolean,
}

const Accounting = (props: AccountingProps) => {
  const { agencyFormPayload, disabled } = props

  const {
    entityState,
    handlers,
  } = agencyFormPayload

  const {
    options: {
      accounting_platform_api,
      sync_xero_payments,
    },
  } = entityState

  const accountingIntegrationPayload = useAccountingIntegration({
    agencyEntityState: entityState,
    shouldFetchAccounts: true,
    shouldFetchConnections: true,
    shouldFetchIntegrationData: true,
  })

  const {
    callbacks: {
      duplicateIntegration,
    },
    creatingIntegration,
    hasActiveSession,
    loadingIntegrationData,
    selectedAgencyId,
    selectedConnection,
    selectedIntegrationId,
  } = accountingIntegrationPayload

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} loading={loadingIntegrationData} title="Accounting">
      {!loadingIntegrationData && (
        <Form padding="large">
          <Form.Row>
            <Form.Field label="Accounting Platform" fieldHolderProps={{}}>
              {/*
               // @ts-expect-error TS2322 */}
              <select
                disabled={disabled}
                name="options.accounting_platform_api"
                value={accounting_platform_api}
                {...handlers}
              >
                <option value="">Please Select...</option>
                <option value="xero">Xero</option>
              </select>
            </Form.Field>

            {/*
             // @ts-expect-error TS2322 */}
            <Form.Field label="Sync Payments" marginTop={['large', 0]}>
              {/*
               // @ts-expect-error TS2322 */}
              <select
                data-value-type="boolean"
                disabled={disabled}
                name="options.sync_xero_payments"
                value={sync_xero_payments}
                {...handlers}
              >
                <option value="">Please Select...</option>
                <option value="false">Off</option>
                <option value="true">On</option>
              </select>
            </Form.Field>
          </Form.Row>

          {/* Show available xero connections if present and not currently connected */}
          {/* TODO: The below dropdown has been removed because it is no longer needed */}
          {/* TODO: When the user connects to Xero, they are redirected to the Xero authentication page */}
          {/* TODO: where they select an account. This is only commented out for the meantime. */}
          {/* {!!connections.length && !hasActiveSession && (
            <Form.Row marginTop="large">
              <Form.Field label="Use Existing Connection">
                <select
                  disabled={disabled}
                  name="options.default_xero_invoice_status"
                  value={selectedIntegrationId}
                  // @ts-expect-error TS2322
                  onChange={(e: ChangeEvent<HTMLInputElement>) => setState({ selectedIntegrationId: +e.target.value })}
                >
                  <option value="">Please Select...</option>
                  {connections.map(connection => (
                    <option key={connection.integration_id} value={connection.integration_id}>
                      {connection.tenant_name}
                    </option>
                  ))}
                </select>
              </Form.Field>
            </Form.Row>
          )} */}

          {hasActiveSession && (
          <ActiveSession
            accountingIntegrationPayload={accountingIntegrationPayload}
            agencyFormPayload={agencyFormPayload}
            disabled={disabled}
          />
          )}
        </Form>
      )}

      <DashboardModule.Footer>
        {!loadingIntegrationData && (
          <DashboardModule.FooterRight>
            {/* If the agency is in a brand group, it can select a connection from another agency to duplicate */}
            {!!selectedIntegrationId && !hasActiveSession && (
            <Button
              buttonStyle="secondaryEdit"
              disabled={disabled}
              // @ts-expect-error TS2322
              ghost
              loading={creatingIntegration}
              // @ts-expect-error TS2322
              onClick={() => duplicateIntegration({ integrable_id: selectedAgencyId, integrable_type: 'Agency' })}
              size="medium"
            >
              {`Connect to ${selectedConnection?.tenant_name}`}
            </Button>
            )}

            {(!selectedIntegrationId || hasActiveSession) && (
            <AccountingIntegrationButton accountingPayload={accountingIntegrationPayload} disabled={disabled} />
            )}
          </DashboardModule.FooterRight>
        )}
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

export default Accounting
